import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@modules/shared.module';
import { NavigationService } from '@services/navigation-service/navigation-service.service';

@Component({
  selector: 'app-button-cancel',
  standalone: true,
  imports: [MatIconModule,MatButtonModule,MatDialogModule,MatDialogClose],
  template: `<button mat-stroked-button
  style="margin-right: 5px; margin-left: 5px"
  color="primary"
  (click)="goBack()"
  [mat-dialog-close]="isDialogClose"
  [disabled]="disabled"
  name="Cancelar">
Cancelar
</button>`,
  styleUrls: ['./button-cancel.component.css'],
})
export class ButtonCancelComponent {
  @Input() disabled!: any
  @Input() isDialogClose: boolean = false


  constructor(private navigationService: NavigationService,
    private route: ActivatedRoute, private router: Router
  ) { }
  goBack(): void {
    if(this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
    else
    this.navigationService.back(); }
}
